/**
 * Vehicles Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const vehiclesAPI = {
  getAll: (params) => apiClient.get('/vehicles', { params }),
  getById: (id) => apiClient.get(`/vehicles/${id}`),
  getSummary: (params) => apiClient.get('/vehicles/stats/summary', { params }),
  create: (data) => apiClient.post('/vehicles', data),
  update: (id, data) => apiClient.put(`/vehicles/${id}`, data),
  updateOdometer: (id, data) => apiClient.patch(`/vehicles/${id}/odometer`, data),
  delete: (id) => apiClient.delete(`/vehicles/${id}`),
  getFuelLogs: (id) => apiClient.get(`/vehicles/${id}/fuel-logs`),
  addFuelLog: (id, data) => apiClient.post(`/vehicles/${id}/fuel-logs`, data),
  deleteFuelLog: (vehicleId, logId) => apiClient.delete(`/vehicles/${vehicleId}/fuel-logs/${logId}`),
};

export default vehiclesAPI;

